import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-processing-conversion',
  templateUrl: './new-processing-conversion.component.html',
  styleUrls: ['./new-processing-conversion.component.scss'],
})
export class NewProcessingConversionComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  conversionData: any;
  conversionForm!: FormGroup;
  conversionAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationlist: any;
  conversionList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  conversionName: any;
  modalName: any;
  @Output() saveNewConversionEvent = new EventEmitter<{
    payload: any;
    pathName: any;
    modalName: any;
  }>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.conversionName =
      this.activatedRoute == 'converting-processes' ? 'Converting process' : 'Conversion';
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.modalName = this.modal?.modalService?.config?.initialState?.['modalName'];
    this.conversionData = this.modal?.modalService?.config?.initialState?.['newConversionData'];
    // eslint-disable-next-line no-constant-condition
    this.isDisabledDropDown =
      this.modalLabel.toLowerCase() == 'review conversion detail' ||
      this.modalLabel.toLowerCase() == 'review conversion process'
        ? true
        : false;

    const placeHolderOrganization = {
      name: 'All organization',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.conversionData.organizationList
    );

    this.regionList = this.conversionData.regionItems;
    this.indicatorList = this.conversionData.indicatiorList;
    this.organizationlist = newOrganizationlist;
    this.conversionList = this.conversionData.convertingProcessItems;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.conversionData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.conversionForm = new FormGroup(form);
    this.conversionAddEditForm = this.formBuilder.group({
      conversion: [this.conversionData.convertingProcessId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [this.conversionData.organizationId || this.organizationlist[0] || null],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChangeData(value: any) {
    this.conversionAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService.GetRegions(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForRegion(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.conversionData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.conversionData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.conversionAddEditForm.patchValue({
      region: this.selectRegion,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.conversionAddEditForm.controls['region'].value?.name == 'Region' ||
      (this.activatedRoute == 'processing-data-conversion' &&
        !this.conversionAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.conversionAddEditForm.status == 'VALID' && this.conversionForm.status == 'VALID') {
      const entires = Object.entries(this.conversionForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.conversionData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const conversionPayload = {
        convertingProcessId: this.conversionAddEditForm.controls['conversion'].value,
        regionId:
          this.conversionAddEditForm.controls['region'].value?.id || this.conversionData.regionId,
        organizationId:
          this.conversionAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.conversionAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.conversionAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveNewConversionEvent.emit({
        payload: conversionPayload,
        pathName: this.activatedRoute,
        modalName: this.modalName,
      });
      this.onClose();
    }
  }
}
